/**
 * Usonian CSS > Elements > List
 */

import { css } from 'styled-components';

export default css`
  li > ul,
  li > ol {
    margin-bottom: 0;
  }
`;
